import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroVideo from './components/HeroVideo';
import InvestmentStrategies from './components/InvestmentStrategies';
import PricingSection from './components/PricingSection';
import SuccessStories from './components/SuccessStories';
import WorkshopCalendar from './components/WorkshopCalendar';
import BlogPreview from './components/BlogPreview';

const OurSolutions = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navigation />
      <main className="pt-20">
        <HeroVideo />
        <InvestmentStrategies />
        <PricingSection />
        <SuccessStories />
        <WorkshopCalendar />
        <BlogPreview />
      </main>
      <Footer />
    </div>
  );
};

export default OurSolutions;